import React, { useState, useEffect } from "react";
import { dispatch } from "store/index";
import {
    FetchAllWhatsappTemplates,
    FetchCreateWhatsAppSetting,
    FetchEditActivity,
    FetchCallActivity,
    StartActivityProcess,
    FetchLeadsCHeckUploadOrNot,
    FetchLeadsCounting,
    FetchActivityDetails,
    FetchWhatsappTemplateSubIDAgains,
} from "store/action/index";
import { useLocation, useNavigate } from "react-router-dom";
import MainCard from "components/MainCard";
import { Table, Button, Select, Typography, Tag, Spin, Modal, Pagination } from "antd";
import { connect, useSelector } from "react-redux";
import AddLeadsDrawer from "./AddLeadDrawer";
import { IoMdAddCircle } from "react-icons/io";
import { toast } from 'react-toastify';
import { EditActivityLeadsLogs } from "components/columns/columns";
import EditActivityWhatsappTemplate from "./editactivitywhatsapptemplate";

const { Option } = Select;
const { Title } = Typography;

const WhatsAppActivityEdit = ({
    whatsappTemplates,
    activityCall,
    leadscountsdata,
    leadscheckornot,
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const initialData = location?.state?.data || {};
    const initialstaus = initialData?.status || 0;
    const [STATUS, setStatus] = useState(initialstaus);
    const [selectedTemplate, setSelectedTemplate] = useState(initialData?.template_id || null);
    const [isVariableModalOpen, setIsVariableModalOpen] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [alldataLoading, setAllDataLoadings] = useState(true);
    const [editActivityTemplate, setEditActivityTemplate] = useState(null);
    const [chekfalsetrue, setcheckfalsetrue] = useState(true);
    const [leadsDataSource, setLeadsDataSource] = useState([]);
    const [documentpaths, setDocumentPaths] = useState(null);
    const [headerTextGet, setHeaderTextGet] = useState("");
    const [headeypingg, setHeaderTypinggg] = useState(null);
    const [isProgrammaticUpdate, setIsProgrammaticUpdate] = useState(false);
    const [hasFormBeenModified, setHasFormBeenModified] = useState(false);
    const [getSettinIDGet, setGetSeetingIGEre] = useState(null);
    const [MainbuttonCLicked, setMainButtonClicked] = useState(false);
    const [newtemplateCreateID, setNewTemplateCreatedID] = useState(null);
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [loadingBtnStart, setLoadingBtnStart] = useState(false)
    const [whatsapp_placeholder, setWhatsappPlaceholder] = useState([]);
    const [whatsapp_headertext_placeholder, setWhatsappHeaderTextPlaceholder] = useState([]);
    const [isLoading, setIsLoading] = useState('')
    const selector = useSelector((state) => state);
    const whatsappSettingData = selector?.AllWhatsappSettingReducer?.allWhatsappsetting?.data ?? [];
    let params = { team_id: localStorage.getItem("teams_id") }
    const [CallParams, setCallParams] = useState({ id: initialData.activity_id_specific, team_id: localStorage.getItem("teams_id"), history_per_page: 10, history_page: 1 })

    const handlePaThhGet = (pathnew) => {
        setDocumentPaths(pathnew);
    };

    const placeholderRegex = /{{(.*?)}}/g; // Yeh regex sab placeholders ko match karega

    const handleGetTexting = (getvalue, headerType) => {
        setHeaderTextGet(getvalue);
        setHeaderTypinggg(headerType)
    };

    const parseTemplateData = (data) => {
        try {
            if (!data?.body) {
                return null;
            }
            return JSON.parse(data.body);
        } catch (error) {
            console.error("Error parsing template data:", error);
            return null;
        }
    };

    const AllchannelData = selector?.AllWhatsappChannnel?.allwhatsappchannel;
    const activeChannels = Array.isArray(AllchannelData)
        ? AllchannelData.filter(channel => channel.active === 1)
        : [];

    useEffect(() => {
        let paramscountleads = { id: location?.state?.data?.records?.id }
        dispatch(FetchLeadsCounting({ params: paramscountleads }));
    }, [leadscheckornot, location?.state?.data?.records])

    useEffect(() => {
        const fetchInitialData = async () => {
            const params = { per_page: "all", team_id: localStorage.getItem("teams_id") };
            const parNams = { team_id: localStorage.getItem("teams_id") };

            try {
                setAllDataLoadings(true);
                await Promise.all([
                    dispatch(FetchAllWhatsappTemplates({ params })),
                    dispatch(FetchCreateWhatsAppSetting({ setLoading: () => { }, params: parNams }))
                ]);
            } catch (error) {
                console.error('Error fetching initial data:', error);
                toast.error('Failed to load initial data.');
            } finally {
                setAllDataLoadings(false);
            }
        };

        fetchInitialData();
    }, []);

    useEffect(() => {
        const fetchActivityData = async () => {
            if (!initialData?.activity_id_specific) return;

            try {
                setAllDataLoadings(true);
                await dispatch(FetchCallActivity({ params: CallParams, setAllDataLoadings }));
            } catch (error) {
                console.error("Error fetching activity data:", error);
                toast.error("Failed to load activity.");
            }
        };

        fetchActivityData();
    }, [initialData?.activity_id_specific, CallParams]);

    useEffect(() => {
        dispatch(FetchCreateWhatsAppSetting({ setLoading: setIsLoading, params }));
        dispatch(FetchLeadsCHeckUploadOrNot({ id: initialData?.activity_id_specific }));
    }, []);

    useEffect(() => {
        if (activityCall?.data?.data[0]?.subject_id && chekfalsetrue) {
            // const initialLeads = initialData?.leads || [];
            // const activityLeads = activityCall?.data?.data[0].leads || [];
            setSelectedProvider({ subjectId: activityCall?.data?.data[0]?.subject_id || null })
            // setLeadsDataSource([...initialLeads, ...activityLeads]);
        }
    }, [activityCall, initialData]);

    const handleTemplateChange = (value) => {
        setSelectedTemplate(value);
        const selectedTemplateData = whatsappTemplates?.data?.find(template => template?.id === value);
        const mainSelectedTemplateData = parseTemplateData(selectedTemplateData);
        // let documentType = mainSelectedTemplateData?.content?.header?.headerType || "";
        // if (documentType !== "TEXT" && STATUS == 0 && location?.state?.data?.activities?.id && location?.state?.data?.activities?.id == "3") {
        //     toast.warning("Upload a header document first, then save the activity.", {
        //         position: "top-center",
        //         autoClose: 4000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         theme: "colored",
        //         style: {
        //             backgroundColor: "#ffcc00",
        //             color: "#000",
        //             fontSize: "16px",
        //             fontWeight: "600",
        //             textAlign: "center",
        //         },
        //         icon: "⚠️", // Warning emoji taake attention grab ho
        //     });
        // }

        if (selectedProvider && mainSelectedTemplateData) {
            const transformedTemplate = {
                name: mainSelectedTemplateData?.name,
                channelType: mainSelectedTemplateData?.channelType,
                body: mainSelectedTemplateData?.content?.text || '',
                footer: mainSelectedTemplateData.content?.footer?.text || '',
                header: {
                    content: mainSelectedTemplateData.content?.header?.text || '',
                    header_type: mainSelectedTemplateData?.content?.header?.headerType,
                    text: mainSelectedTemplateData?.text,
                    headerExampleMediaUrl: mainSelectedTemplateData?.content?.header?.headerExampleMediaUrl
                },
                subject: selectedProvider.subject || '',
                category: mainSelectedTemplateData?.category,
                subjectId: selectedProvider.subjectId || '',
                Template_Status: mainSelectedTemplateData.status || '',
                content: {
                    keyboard: {
                        rows: mainSelectedTemplateData.content?.keyboard?.rows || []
                    }
                }
            };

            setIsProgrammaticUpdate(true);
            setEditActivityTemplate(transformedTemplate);
            setTimeout(() => setIsProgrammaticUpdate(false), 100);
        }
    };

    const handleNavigate = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (whatsappTemplates?.data?.length !== 0 && initialData?.template_id) {
            handleTemplateChange(initialData?.template_id)
        }
    }, [whatsappTemplates, initialData?.template_id])

    // const HandleSave = async (status_id) => {
    //     if (!activityCall?.data?.activity_history?.data || activityCall?.data?.activity_history?.data?.length === 0) {
    //         Modal.error({
    //             title: "No Leads Available",
    //             content: "There are no leads, so you cannot save this activity.",
    //         });
    //     } else {
    //         if (leadscheckornot?.message?.toLowerCase() === "jobs are pending") {
    //             dispatch(FetchLeadsCHeckUploadOrNot({ id: initialData?.activity_id_specific }));
    //             Modal.error({
    //                 title: "Processing Leads",
    //                 content: "The uploaded leads are still being processed. Please try again after a short while.",
    //             });
    //         } else {

    //             setMainButtonClicked(true);
    //             if (status_id === 1) {
    //                 if (!selectedTemplate) {
    //                     toast.error("Template must be selected");
    //                     return;
    //                 }
    //                 if (!selectedProvider) {
    //                     toast.error("Provider must be selected");
    //                     return;
    //                 }
    //             }

    //             // const matchedPlaceholders = editActivityTemplate?.body?.match(placeholderRegex) || [];
    //             // if (matchedPlaceholders?.length > 0 && matchedPlaceholders?.length !== whatsapp_placeholder?.length) {
    //             //     setIsVariableModalOpen(true)
    //             //     Modal.error({
    //             //         title: "Missing WhatsApp Placeholder",
    //             //         content: "Please enter a placeholder value.",
    //             //     });
    //             //     return;
    //             // }

    //             if (
    //                 headeypingg &&
    //                 (headeypingg == "IMAGE" || headeypingg == "VIDEO" || headeypingg == "DOCUMENT") &&
    //                 (!documentpaths || documentpaths.trim() === "")
    //             ) {
    //                 Modal.error({
    //                     title: "Missing Header Document",
    //                     content: "Please attach a Header document in Template.",
    //                 });
    //                 return;
    //             }

    //             // Wait for template creation before proceeding
    //             if (hasFormBeenModified) {
    //                 // Navigation will be handled by the child component
    //                 return;
    //             }
    //             // If no modifications, proceed with normal save
    //             const payload = {
    //                 activity_id: initialData?.activity_id_specific,
    //                 campaign_id: initialData?.campaign_id,
    //                 template_id: newtemplateCreateID || selectedTemplate,
    //                 whatsapp_header: headerTextGet ? headerTextGet : documentpaths,
    //                 // setting_id: selectedProvider?.id,
    //                 activity_campaign_setting_id: location?.state?.data?.records?.id,
    //                 setting_id: getSettinIDGet,
    //                 whatsapp_placeholder: whatsapp_placeholder?.map(item => item?.type == "text" ? item?.text : item?.type),
    //                 whatsapp_header_placeholder: whatsapp_headertext_placeholder?.map(item => item?.type == "text" ? item?.text : item?.type),
    //                 subject_id: selectedProvider?.subjectId,
    //                 status: status_id,
    //             };
    //             setLoadingBtn(true)
    //             dispatch(FetchEditActivity({ fieldData: payload, setLoadingBtn: setLoadingBtn, isNavigate: handleNavigate, params }));

    //         }
    //     }

    // };

    const HandleSave = async (status_id) => {
        try {
            // If status_id is NOT 2, perform these validations
            if (status_id !== 2) {
                if (!activityCall?.data?.activity_history?.data || activityCall?.data?.activity_history?.data?.length === 0) {
                    Modal.error({
                        title: "No Leads Available",
                        content: "There are no leads, so you cannot save this activity.",
                    });
                    return;
                }

                if (leadscheckornot?.message?.toLowerCase() === "jobs are pending") {
                    dispatch(FetchLeadsCHeckUploadOrNot({ id: initialData?.activity_id_specific }));
                    Modal.error({
                        title: "Processing Leads",
                        content: "The uploaded leads are still being processed. Please try again after a short while.",
                    });
                    return;
                }
            }

            setMainButtonClicked(true);

            if (status_id === 1) {
                if (!selectedTemplate) {
                    toast.error("Template must be selected");
                    return;
                }
                if (!selectedProvider) {
                    toast.error("Provider must be selected");
                    return;
                }
            }

            if (
                headeypingg &&
                (headeypingg === "IMAGE" || headeypingg === "VIDEO" || headeypingg === "DOCUMENT") &&
                (!documentpaths || documentpaths.trim() === "")
            ) {
                Modal.error({
                    title: "Missing Header Document",
                    content: "Please attach a Header document in Template.",
                });
                return;
            }

            if (hasFormBeenModified) {
                return; // Let the child handle navigation
            }

            const payload = {
                activity_id: initialData?.activity_id_specific,
                campaign_id: initialData?.campaign_id,
                template_id: newtemplateCreateID || selectedTemplate,
                whatsapp_header: headerTextGet ? headerTextGet : documentpaths,
                activity_campaign_setting_id: location?.state?.data?.records?.id,
                setting_id: getSettinIDGet,
                whatsapp_placeholder: whatsapp_placeholder?.map(item => item?.type === "text" ? item?.text : item?.type),
                whatsapp_header_placeholder: whatsapp_headertext_placeholder?.map(item => item?.type === "text" ? item?.text : item?.type),
                subject_id: selectedProvider?.subjectId,
                status: status_id,
            };

            setLoadingBtn(true);
            dispatch(FetchEditActivity({
                fieldData: payload,
                setLoadingBtn: setLoadingBtn,
                isNavigate: handleNavigate,
                params
            }));

        } catch (error) {
            console.error("Error in HandleSave:", error);
            toast.error("Something went wrong while saving.");
        }
    };


    const ProccedHitApi = () => {
        setLoadingBtnStart(true)
        dispatch(StartActivityProcess({ activity_id: initialData?.records?.id, setLoadingBtnStart: setLoadingBtnStart, isNavigate: handleNavigate, params }));
    }

    useEffect(() => {
        if (selectedProvider?.subjectId) {
            dispatch(FetchWhatsappTemplateSubIDAgains({ subjecdId: selectedProvider?.subjectId, setLoading: () => { }, params }));
        }
    }, [selectedProvider])

    const handleTemplateCreated = (templateId) => {
        setNewTemplateCreatedID(templateId)
        if (selectedProvider?.subjectId) {
            dispatch(FetchWhatsappTemplateSubIDAgains({ subjecdId: selectedProvider?.subjectId, setLoading: () => { }, params }));
        }
    };

    // const getActivityHistory = () => {
    //     if (activityCall?.data?.data && Array.isArray(activityCall?.data?.data) && activityCall?.data?.data?.length > 0) {
    //         return activityCall.data?.data[0]?.activity_history || [];
    //     }
    //     return [];
    // };

    const getActivityHistory = () => {
        if (activityCall?.data?.activity_history?.data && Array.isArray(activityCall?.data?.activity_history?.data) && activityCall?.data?.activity_history?.data?.length > 0) {
            return activityCall?.data?.activity_history?.data || [];
        }
        return [];
    };

    const handlePageChange = (history_page) => {
        setcheckfalsetrue(false)
        setCallParams({ ...CallParams, history_page });
    };

    return (
        <>
            <Spin spinning={alldataLoading}>
                <MainCard>
                    <div>
                        <h3 style={{ marginBottom: "20px" }}>Edit {location?.state?.data?.records?.name + " WhatsApp" || "WhatsApp"} Activity {leadscheckornot?.message?.toLowerCase() === "jobs are pending" ? <span style={{ color: "red", fontSize: "18px" }}>The uploaded leads are still being processed.</span> : ""}</h3>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ justifyContent: "left" }}>
                                <AddLeadsDrawer
                                    leadsDataSource={[]}
                                    datacampaign={initialData}
                                    handleNavigate={handleNavigate}
                                    status={STATUS} >
                                    {(STATUS == 0 || STATUS == 2) && (leadscheckornot?.message?.toLowerCase() !== "jobs are pending") && (<Button
                                        style={{
                                            backgroundColor: "#0055A2",
                                            color: "#fff",
                                            fontFamily: "poppins",
                                            fontSize: "13px",
                                        }}
                                        size="large"
                                    >
                                        <IoMdAddCircle color="#fff" size={24} />
                                        Add Leads
                                    </Button>)}
                                </AddLeadsDrawer>
                            </div>


                            <div style={{ display: "flex", gap: 10 }}>
                                {/* <div className="count-box">
                                    <span>Total: </span>
                                    {activityCall?.data?.activity_history?.data?.length || 0}
                                </div> */}
                                <div className="count-box">
                                    <span>Total: </span>
                                    {leadscountsdata?.campaign_count + leadscountsdata?.count || 0}
                                </div>

                                {/* <div className="count-box">
                                    <span>New: </span>
                                    {activityCall?.data?.data?.[0]?.leads?.length || 0}
                                </div> */}
                                <div className="count-box">
                                    <span>New: </span>
                                    {leadscountsdata?.count || 0}
                                </div>


                            </div>
                        </div>

                        <div style={{ marginTop: 30, display: "flex", gap: 20 }}>
                            <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'column' }}>
                                <label style={{ marginBottom: 5, fontSize: 13 }}>Select Channels</label>
                                <Select
                                    placeholder="Provider"
                                    style={{ width: 300 }}
                                    value={selectedProvider ? selectedProvider.subjectId : undefined} // Display subjectId only
                                    disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                    onChange={(subjectId) => {
                                        const selected = activeChannels.find((setting) => setting.subjectId === subjectId);
                                        setSelectedProvider(selected);
                                    }}
                                >
                                    {Array.isArray(activeChannels) && activeChannels.length !== 0 && activeChannels.map((setting) => (

                                        <Option key={setting.id} value={setting.subjectId}> {/* Pass subjectId as the value */}
                                            {setting.name}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'column' }}>
                                <label style={{ marginBottom: 5, fontSize: 13 }}>Select Template</label>
                                <Select
                                    placeholder="Select Template"
                                    style={{ width: 300 }}
                                    value={selectedTemplate}
                                    disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                    onChange={handleTemplateChange}
                                >
                                    {Array.isArray(whatsappTemplates?.data) && whatsappTemplates?.data?.length > 0 && whatsappTemplates?.data?.map((e) => parseTemplateData(e))
                                        .filter((template) => template.status == "APPROVED")
                                        .map((template) => (
                                            <Option key={template?.id} value={template?.id}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <span>{template.name}</span>
                                                    <Tag
                                                        style={{ fontSize: 9, padding: '2px 6px', lineHeight: '16px' }}
                                                        color="green"
                                                    >
                                                        {template.status}
                                                    </Tag>
                                                </div>
                                            </Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </div>

                        <div style={{ marginTop: 20 }}>
                            <EditActivityWhatsappTemplate
                                isDisabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                STATUS={STATUS}
                                EditActivityTemplate={editActivityTemplate}
                                setHasFormBeenModified={setHasFormBeenModified}
                                isProgrammaticUpdate={isProgrammaticUpdate}
                                setGetSeetingIGEre={setGetSeetingIGEre}
                                setIsProgrammaticUpdate={setIsProgrammaticUpdate}
                                isVariableModalOpen={isVariableModalOpen}
                                setIsVariableModalOpen={setIsVariableModalOpen}
                                selectedTemplate={selectedTemplate}
                                setSelectedTemplate={setSelectedTemplate}
                                hasFormBeenModified={hasFormBeenModified}
                                MainbuttonCLicked={MainbuttonCLicked}
                                onTemplateCreated={handleTemplateCreated}
                                whatsapp_placeholder={whatsapp_placeholder}
                                whatsapp_headertext_placeholder={whatsapp_headertext_placeholder}
                                setWhatsappHeaderTextPlaceholder={setWhatsappHeaderTextPlaceholder}
                                setWhatsappPlaceholder={setWhatsappPlaceholder}
                                onUrlSenderTemplatesChange={handlePaThhGet} // Passing function
                                onPassHeadTextings={handleGetTexting}

                            />
                        </div>
                        <div style={{ display: "flex", justifyContent: "end", gap: 30, marginTop: 20 }}>

                            {(STATUS == 0 || STATUS == 2) && (
                                <>
                                    <Button
                                        style={{
                                            backgroundColor: "#0055A2",
                                            color: "#fff",
                                            fontFamily: "poppins",
                                            fontSize: "13px",
                                            minWidth: "150px",
                                        }}
                                        onClick={() => HandleSave(1)}
                                        size="large"
                                        loading={loadingBtn}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        style={{
                                            backgroundColor: "#0055A2",
                                            color: "#fff",
                                            fontFamily: "poppins",
                                            fontSize: "13px",
                                            minWidth: "150px",
                                        }}
                                        onClick={() => HandleSave(2)}
                                        size="large"
                                        loading={loadingBtn}
                                    >
                                        Save as Draft
                                    </Button>
                                </>
                            )}

                            {STATUS == 1 ? <Button
                                // <Button
                                style={{
                                    backgroundColor: "#0055A2",
                                    color: "#fff",
                                    fontFamily: "poppins",
                                    fontSize: "13px",
                                }}
                                size="large"
                                loading={loadingBtnStart}
                                onClick={ProccedHitApi}
                            >
                                Start
                                {/* </Button> */}
                            </Button> : <></>}
                        </div>

                        <div style={{ overflowX: "auto" }}>
                            <Table
                                className="border rounded"
                                style={{ marginTop: 25 }}
                                dataSource={getActivityHistory()}
                                pagination={false}
                                columns={EditActivityLeadsLogs()}
                            />
                            <div style={{ textAlign: "center", marginTop: 16 }}>
                                <Pagination
                                    current={activityCall?.data?.activity_history?.current_page || 1}
                                    total={activityCall?.data?.activity_history?.total || 0}
                                    pageSize={activityCall?.data?.activity_history?.per_page || 10}
                                    onChange={handlePageChange}
                                    showSizeChanger={false}
                                />
                            </div>
                        </div>
                    </div>

                </MainCard>
            </Spin >
        </>
    );
};

const mapStateToProps = (state) => ({
    whatsappTemplates: state?.WhatsappTemplatesReducer?.whatsappTemplates,
    activityCall: state?.ActivityCallRedc?.activityCall,
    leadscountsdata: state?.ActivityWiseLeadsCounts?.leadscountsdata,
    leadscheckornot: state?.LeadsCheckReducerUPNot?.leadscheckornot,
});

export default connect(mapStateToProps)(WhatsAppActivityEdit);